var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHandHoldingBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.20642 14.2222H8.03181M9.20642 14.2222H10.5235C11.1844 14.2222 11.8182 13.9624 12.2855 13.5L15.3732 10.4444C15.8597 9.96296 16.6486 9.96296 17.1351 10.4444C17.6216 10.9259 17.6216 11.7066 17.1351 12.188L13.6974 15.59C12.1372 17.1339 10.0308 18 7.83573 18H2.5M9.20642 14.2222C9.85515 14.2222 10.381 13.7018 10.381 13.0598C10.381 12.4179 9.85515 11.8974 9.20642 11.8974H6.71468C6.05383 11.8974 5.42005 12.1572 4.95276 12.6197L4.55102 13.0172C3.97326 13.589 3.27119 13.9748 2.5 14.1365M6.66667 3H4.16667C3.70643 3 3.33333 3.3731 3.33333 3.83333V8C3.33333 8.46024 3.70643 8.83333 4.16667 8.83333H12.5C12.9602 8.83333 13.3333 8.46024 13.3333 8V3.83333C13.3333 3.3731 12.9602 3 12.5 3H10M6.66667 3V6.33333L8.33333 5.91667L10 6.33333V3M6.66667 3H10",
    stroke: "#131C7A",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandHoldingBox);
export default __webpack_public_path__ + "static/media/hand-holding-box.d83f3ac3b5890b026d3414eeaad062ff.svg";
export { ForwardRef as ReactComponent };